import { createContext, useContext } from "react";

export interface IWorkspace {
  id: number;
  name: string;
  website: null | string;
  description: null | string;
  updated_at: string;
  created_at: string;
}

export interface IPanelContext {
  drawerOpen: boolean;
  setDrawerOpen: (payload: boolean) => void;
}

const panelContext = createContext<IPanelContext>({
  drawerOpen: false,
  setDrawerOpen: () => false,
});

export function PanelContextProvider({
  drawerOpen,
  setDrawerOpen,
  ...props
}: any) {
  return (
    <panelContext.Provider
      value={{
        drawerOpen,
        setDrawerOpen,
      }}
      {...props}
    />
  );
}

export const usePanelContext = () => useContext(panelContext);
